import React from 'react';
import { Sparkles, Heart, LogIn } from 'lucide-react';

interface LoginScreenProps {
  loading: boolean;
  loggingIn: boolean;
  onLogin: () => void;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ loading, loggingIn, onLogin }) => {
  return (
    <div className="h-screen flex flex-col items-center justify-center p-4 text-center relative overflow-hidden bg-gradient-to-b from-cream to-coral-100">
      {/* Decorative floating hearts */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(6)].map((_, i) => (
          <Heart
            key={i}
            size={16 + i * 4}
            className="absolute text-coral-500/10"
            style={{
              left: `${15 + i * 14}%`,
              top: `${10 + (i % 3) * 25}%`,
              transform: `rotate(${-15 + i * 12}deg)`,
            }}
          />
        ))}
      </div>

      <div className="z-10 relative max-w-md w-full">
        {/* Logo */}
        <div className="mb-8">
          <h1 className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-coral-500 to-amber-accent flex items-center justify-center gap-2">
            <Sparkles size={24} className="text-amber-accent" />
            赛博红娘
            <Sparkles size={24} className="text-amber-accent" />
          </h1>
          <p className="text-lg text-[#6B7280] mt-2 font-medium">这也配？</p>
        </div>

        {/* Login card */}
        <div className="bg-white/70 backdrop-blur-sm rounded-2xl shadow-lg p-8 mx-4">
          <div className="mb-6">
            <p className="text-[#4B5563] text-sm leading-relaxed">
              欢迎来到赛博红娘！<br />
              请先登录以开始你的神级红娘之旅。
            </p>
          </div>

          <button
            onClick={onLogin}
            disabled={loading || loggingIn}
            className="w-full px-8 py-4 rounded-full bg-gradient-to-r from-coral-500 to-amber-accent hover:from-coral-700 hover:to-coral-500 active:from-coral-700 active:to-coral-500 active:scale-95 text-white font-bold text-lg tracking-wider shadow-lg transition-all hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            style={{ touchAction: 'manipulation' }}
          >
            {loading || loggingIn ? (
              <>
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                {loggingIn ? '正在跳转登录...' : '加载中...'}
              </>
            ) : (
              <>
                <LogIn size={20} />
                登录 / 注册
              </>
            )}
          </button>
        </div>
      </div>

      <div className="absolute bottom-4 text-xs text-[#9CA3AF] z-10">
        Powered by Wortou AI
      </div>
    </div>
  );
};

export default LoginScreen;
